import React from 'react';
import { motion } from 'framer-motion';
import { Fuel, Warehouse, Wrench, GraduationCap, UtensilsCrossed, Tent, Cloud, Plane } from 'lucide-react';
function ParachuteIcon({
  className
}: {
  className?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-475">
      {/* Canopy */}
      <path d="M4 12C4 7.58 7.58 4 12 4s8 3.58 8 8" data-id="element-476" />
      {/* Canopy segments */}
      <path d="M4 12c0-2.5 2.67-4.5 4-4.5S10.67 10 12 10s2.67-2.5 4-2.5S20 9.5 20 12" data-id="element-477" />
      {/* Lines from canopy to person */}
      <line x1="4" y1="12" x2="11" y2="20" data-id="element-478" />
      <line x1="20" y1="12" x2="13" y2="20" data-id="element-479" />
      {/* Person */}
      <circle cx="12" cy="21" r="1" fill="currentColor" data-id="element-480" />
    </svg>;
}
const services = [{
  icon: Fuel,
  title: 'Palivo',
  description: 'BA 95 dostupný u čerpací stanice 200m od letiště. AVGAS není na letišti k dispozici. Olej TOTAL AERO 100.'
}, {
  icon: Warehouse,
  title: 'Hangárování',
  description: 'Omezená kapacita pro cizí letadla. Nutno předem projednat s Aviatickým klubem Tlustice.'
}, {
  icon: ParachuteIcon,
  title: 'Výsadková činnost',
  description: 'Letiště je využíváno pro sportovní parašutismus. Dbejte zvýšené opatrnosti při příletu.'
}, {
  icon: GraduationCap,
  title: 'Letecká škola',
  description: 'Výcvikové lety jiných provozovatelů pouze s písemným souhlasem vedoucího letového provozu.'
}, {
  icon: Tent,
  title: 'Ubytování',
  description: 'Ubytovací možnosti v omezeném rozsahu pouze po předchozím projednání s provozovatelem.'
}, {
  icon: Cloud,
  title: 'Meteorologické údaje',
  description: 'Vlastní měření tlaku, větru a dohlednosti na stanovišti RADIO. Data z ČHMÚ Praha-Ruzyně.'
}];
export function Services() {
  return <section id="services" className="py-24 bg-[#0a1628]" data-id="element-481">
      <div className="max-w-7xl mx-auto px-6" data-id="element-482">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16 text-center" data-id="element-483">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-484">
            Naše služby
          </h2>
          <div className="w-24 h-1 bg-[#38bdf8] mx-auto rounded-full" data-id="element-485" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-486">
          {services.map((service, index) => <motion.div key={service.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-[#0f1d35] border border-white/5 rounded-xl p-8 hover:border-[#38bdf8]/30 transition-all duration-300 group" data-id="element-487">
              <div className="mb-6 inline-block p-3 bg-[#0a1628] rounded-lg group-hover:bg-[#38bdf8]/10 transition-colors" data-id="element-488">
                <service.icon className="w-8 h-8 text-[#38bdf8]" data-id="element-489" />
              </div>
              <h3 className="text-xl font-semibold text-white mb-3 group-hover:text-[#38bdf8] transition-colors" data-id="element-490">
                {service.title}
              </h3>
              <p className="text-white/60 leading-relaxed" data-id="element-491">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}